import { put } from "redux-saga/effects";
import axiosGovernorate from "../../axios-governorate";
import * as actions from "../actions";

export function* sendThievesSaga({
  actionType,
  targetId,
  influence,
  sender,
  isOwner
}: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "sendThieves",
      actionType,
      targetId,
      influence,
      sender
    });

    const { data } = JSON.parse(response.data);
    const {
      resources,
      resourceBalances,
      crimes,
      limitingCrimes,
      crimesLimit,
      canSendCounterintelligence,
      crimeTypes,
      opponent,
      general
    } = data;

    if (isOwner) {
      yield put(actions.updateState({
        crimes,
        limitingCrimes,
        crimesLimit,
        canSendCounterintelligence,
        crimeTypes,
        opponent
      }));

      yield put(actions.updateResources({
        resources,
        resourceBalances
      }));

      yield put(actions.updateGeneral(
        general,
      ));
    }

    yield put(actions.updateMember(sender, {
      resources: {
        gold: resources.gold,
        weapons: resources.weapons,
        mana: resources.mana,
        magicEnergy: resources.magicEnergy
      },
      crimes,
      limitingCrimes,
      crimesLimit,
      canSendCounterintelligence,
      crimeTypes,
      opponent
    }));
  } catch (error) {
    console.log(error.message);
  }
}

export function* cancelThievesSaga({
  actionType,
  targetId,
  sender,
  isOwner
}: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "cancelThieves",
      atid: actionType,
      targetId,
      sender
    });

    const { data } = JSON.parse(response.data);
    const {
      resources,
      resourceBalances,
      crimes,
      limitingCrimes,
      crimesLimit,
      canSendCounterintelligence,
      crimeTypes,
      opponent,
      general
    } = data;

    if (isOwner) {
      yield put(actions.updateState({
        crimes,
        limitingCrimes,
        crimesLimit,
        canSendCounterintelligence,
        crimeTypes,
        opponent
      }));

      yield put(actions.updateResources({
        resources,
        resourceBalances
      }));

      yield put(actions.updateGeneral(
        general,
      ));
    }

    yield put(actions.updateMember(sender, {
      resources: {
        gold: resources.gold,
        weapons: resources.weapons,
        mana: resources.mana,
        magicEnergy: resources.magicEnergy
      },
      crimes,
      limitingCrimes,
      crimesLimit,
      canSendCounterintelligence,
      crimeTypes,
      opponent
    }));
  } catch (error) {
    console.log(error.message);
  }
}
